import Personnummer from 'personnummer';

export const ageResolver = (cpr: string) => Personnummer.parse(cpr).getAge();

export const isVolontaryPhoneValid = (phoneNr: string) => {
  if (!phoneNr) {
    return true;
  }

  if (!/^[0-9]*$/.test(phoneNr)) {
    return false;
  }

  if (phoneNr.length < 9 || phoneNr.length > 10) {
    return false;
  }

  return true;
};
